module.exports = __webpack_public_path__ + "img/sol_cap1.89caa5d9.png";